module.exports = __webpack_public_path__ + "static/no_sweast_mobile-d75309418e755b3ff5b79dc951a6b7c1.webp";